module.exports = __webpack_public_path__ + "static/img/cpjzx_2@2x.3c2a5db8.png";